import { ReactNode, useState } from "react";

//STYLES
import styles from "../NavBar.module.scss";

//ASSETS
import collapsableUpIcon from "../../../assets/images/icons/ui/arrows/collapsable-up.svg";
import collapsableDownIcon from "../../../assets/images/icons/ui/arrows/collapsable-down.svg";

//TYPES
import { NavItem } from "../interfaces/types";

const NavItemAccordion = ({
  navItem,
  children,
}: {
  navItem: NavItem;
  children: ReactNode;
}) => {
  const {
    navAccordionContainer,
    navAccordionHeader,
    selected,
    acordionChildrenContainer,
    accordionOpen,
    accordionClose,
  } = styles;

  const { label } = navItem;

  const [navItemOpen, setNavItemOpen] = useState(false);

  const toggleNavItem = () => {
    setNavItemOpen((prevState) => !prevState);
  };

  return (
    <div className={navAccordionContainer}>
      <div
        onClick={toggleNavItem}
        className={`${navAccordionHeader} ${navItemOpen ? selected : ""}`}
      >
        <div>
          <span>{label}</span>
        </div>

        <div className={` ${navItemOpen ? selected : ""}`}>
          {navItemOpen ? (
            <img src={collapsableUpIcon} alt="Collapsable Up Icon" />
          ) : (
            <img src={collapsableDownIcon} alt="Collapsable Down Icon" />
          )}
        </div>
      </div>

      <div
        className={`${acordionChildrenContainer} ${
          navItemOpen ? accordionOpen : accordionClose
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default NavItemAccordion;
